<!--
 * @Descripttion: 
 * @version: 
 * @Author: lubaicen
 * @Date: 2020-09-16 18:27:10
 * @LastEditors: lubaicen
 * @LastEditTime: 2020-10-19 16:40:58
-->
<template>
    <ux-form ref="form" class="add-field-input x-flex-align" :data="formData" :rules="rules" :show-message="false" label-width="0px" :hideBtn="true">
        <ux-form-item prop="mapping_name" :style="flexStyle(0)">
            <ux-input v-model="formData.mapping_name" size="small" placeholder="" @input=""></ux-input>
        </ux-form-item>
        <ux-form-item prop="mapping_position" :style="flexStyle(1)">
            <ux-select v-model="formData.mapping_position" :options="$opt.parameter"></ux-select>
        </ux-form-item>
        <ux-form-item :style="flexStyle(2)">
            <span class="label-center">{{formData.name}}</span>
        </ux-form-item>
        <ux-form-item :style="flexStyle(3)">
            <span class="label-center">{{$opt.switchStr(formData.position, $opt.parameter)}}</span>
        </ux-form-item>
        <ux-form-item :style="flexStyle(4)">
            <span class="label-center">{{$opt.switchStr(formData.type, $opt.dataType)}}</span>
        </ux-form-item>
    </ux-form>
</template>

<script>
export default {
  props: {
    columns1: { // 表头数据
      type: Array,
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formData: this.data,
      rules: this.$rul.params()
    };
  },

  methods: {

    /**
         * 生成表单和表格对应的每个宽度布局
         * @param {Array} index 查询对象
         */
    flexStyle(index) {
      let width = this.columns1[index]['width'];
      if (width === undefined) { // 无设置width
        return {'flex': 1};
      }
      if (typeof width === 'number') {
        return {'flex-basis': width+'px'};
      }
      if (width.indexOf('px') ) { // width添加单位px
        return {'flex-basis': width};
      } else {
        return {'flex-basis': width+'px'};
      }    
    }
  },

  watch: {
    data: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    }
  },
    
};
</script>

<style lang="scss" scoped>
    .add-field-input {
        width: 100%;
        height: 100%;

        .ux-form-item {
            padding: 0 10px;
            margin-bottom: 0 !important ;
        }
        .label-center {
            width: 100%;
            text-align: center;
        }
    }
</style>